import { useQuery } from '@tanstack/react-query';
import { CommunityQueryKeys } from './community.keys';
import community_api from './community.services';

export const useRecommendedCommunities = (params: any = {}) => {
  return useQuery({
    queryKey: CommunityQueryKeys.recommended,
    queryFn: () => community_api.Communities(params),
  });
};
